import api from "./api";
import type { ThemePalette } from "../theme/palette";
import {
  currentRouterPath,
  isRootStorefront,
} from "../config/storefrontRouting";

export interface StorefrontFeatures {
  freeShipping: boolean;
  easyReturns: boolean;
  securePayment: boolean;
}

export interface ResolvedTenant {
  id: string;
  name: string;
  nameAr: string | null;
  slug: string;
  email: string;
  phone: string | null;
  address: string | null;
  logoUrl: string | null;
  faviconUrl: string | null;
  logoMediaId: string | null;
  faviconMediaId: string | null;
  logoMediaUrl?: string | null;
  faviconMediaUrl?: string | null;
  currencyCode: string;
  languageCode: string;
  theme: Partial<ThemePalette> | null;
  features?: StorefrontFeatures;
  domain: string | null;
  isActive: true;
  resolution: {
    mode: "path" | "domain";
    matchedBy: "slug" | "domain";
    fallback: boolean;
    note?: string;
  };
  /** Combined public flag from tenant resolve. Missing/false hides the storefront AI widget. */
  aiEnabled?: boolean;
}

export function getTenantPath(): string {
  if (typeof window === "undefined") return "/";
  if (isRootStorefront()) return "/";
  const path = currentRouterPath();
  // Only `/site/:slug` identifies the tenant. Including deeper segments
  // (e.g. `/categories/12`) busts React Query caches on every tab switch
  // and remounts the storefront — which also resets scroll position.
  const siteMatch = path.match(/^(\/site\/[^/?#]+)/i);
  if (siteMatch) return siteMatch[1];
  return path || "/";
}

export const tenantService = {
  async resolve(): Promise<ResolvedTenant> {
    const response = await api.get("/tenant/resolve", {
      headers: { "x-tenant-path": getTenantPath() },
    });
    return (response.data?.data ?? response.data) as ResolvedTenant;
  },
};
